export class PaxModel {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  passengersCount: number;
  paxCodes: number[];

  constructor(minPax: number) {
    this.firstName = '';
    this.lastName = '';
    this.phone = '';
    this.email = '';
    this.passengersCount = minPax;
    this.paxCodes = [];
  }
}
